import { computed, Injectable } from '@angular/core';
import {
    FolderValidationErrorObject,
} from '@libs/types/src/services/object-type/folder/folder-validation-error.object';
import { ComponentStoreV2Factory } from '../../../../../shared/store/common/component-store-v2.factory';

@Injectable()
export class ErrorsInFolderWidgetStore extends ComponentStoreV2Factory {
    public readonly validationErrors = computed<FolderValidationErrorObject[]>(() =>
        this.data.getFolderValidationErrors()?.items ?? [],
    );

    public readonly organizationId = this.globalGlobalStore.organizationStore.selectedId;
}
